/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refund_TitleInputs */

const vi_refund_title = /** @type {(inputs: Refund_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn tiền cho khách`)
};

/**

* @param {Refund_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const refund_title = /** @type {((inputs?: Refund_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refund_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_refund_title(inputs)
});